<!-- Zweck: Stellt die HTML-Struktur für shop artikel aktionen stage component im Frontend bereit. -->
@if ((aktion|async)) {
  @if ((aktion|async).AbMenge) {
    ab {{(aktion|async).AbMenge}} -
  }
  @if ((aktion|async).Draufgabemenge) {
    <span>{{ (aktion|async).Draufgabemenge }}</span>
    @if ((aktion|async).Draufgabeartikel) {
      <span> - {{ (aktion|async).Draufgabeartikel.ArtikelName }}</span> <article-dtp-icon [isDtp]="(aktion|async).Draufgabeartikel.IstDtpArtikel"></article-dtp-icon>
    }
  }
  @if ((aktion|async).AktionsrabattProzentsatz) {
    <span>{{ (aktion|async).AktionsrabattProzentsatz }} %</span>
  }
  @if ((aktion|async).AktionsKundeneinkaufspreis) {
    <span>{{ (aktion|async).AktionsKundeneinkaufspreis }} &euro;</span>
    <feature-block [features]="['ShopAktionenDurchrechnen']">
      @if (!(aktion|async).AktionsKundeneinkaufspreis) {
        <span>
              @if ((aktion|async).Draufgabemenge) {
                <span>
                  {{ ((artikel.PreisLtPreiscodeMitPotentiellAufschlag * (aktion|async).AbMenge) / ((aktion|async).AbMenge + (aktion|async).Draufgabemenge))|NiceNumber }}
                  &euro;<br>(durchgerechnet)
                </span>
              }
          @if ((aktion|async).AktionsrabattProzentsatz) {
            <span>
                  {{ (artikel.PreisLtPreiscodeMitPotentiellAufschlag * (1 - ((aktion|async).AktionsrabattProzentsatz / 100)))|NiceNumber }}
              &euro;<br>(durchgerechnet)
                </span>
          }
            </span>
      }
    </feature-block>
  }
}
